import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2 } from 'lucide-react';

const INTENSIDAD_LABEL = {
  leve: 'Leve',
  moderada: 'Moderada',
  vigorosa: 'Vigorosa',
};

/**
 * Chip secundario verde que se muestra junto al badge del escenario clínico
 * cuando el profesional marcó "Apto médico entregado".
 *
 * Formato: "Apto médico — {Moderada, Vigorosa}" (intensidades habilitadas, capitalizadas).
 * Si el apto NO fue entregado, no renderiza nada (comportamiento neutro).
 *
 * Solo capa de presentación: no toca motor ni escenario ni color original.
 */
export default function AptoMedicoChip({ evaluation }) {
  if (!evaluation || !evaluation.apto_medico_entregado) return null;

  const intensidades = Array.isArray(evaluation.apto_intensidades_habilitadas)
    ? evaluation.apto_intensidades_habilitadas
    : [];

  const labels = intensidades
    .map((i) => INTENSIDAD_LABEL[String(i).toLowerCase()])
    .filter(Boolean);

  const suffix = labels.length > 0 ? ` — ${labels.join(', ')}` : '';

  return (
    <Badge
      data-testid={`apto-chip-${evaluation.id || 'x'}`}
      className="font-medium text-xs border bg-green-50 border-green-200 text-green-800 hover:bg-green-100 font-['Inter'] whitespace-nowrap"
    >
      <CheckCircle2 className="h-3 w-3 mr-1" />
      Apto médico{suffix}
    </Badge>
  );
}
